const ACCESS_LEVELS = {
  OWNER: 'owner',
  EDITOR: 'editor',
  VIEWER: 'viewer'
};

const DEFAULT_PERMISSIONS = {
  [ACCESS_LEVELS.OWNER]: {
    canRenameProject: true,
    canDeleteProject: true,
    canEditProjectContent: true
  },
  [ACCESS_LEVELS.EDITOR]: {
    canRenameProject: false,
    canDeleteProject: false,
    canEditProjectContent: true
  },
  [ACCESS_LEVELS.VIEWER]: {
    canRenameProject: false,
    canDeleteProject: false,
    canEditProjectContent: false
  }
};

const normalizeAccessLevel = (level) => {
  if (typeof level !== 'string') return ACCESS_LEVELS.OWNER;
  const normalized = level.trim().toLowerCase();
  return Object.values(ACCESS_LEVELS).includes(normalized) ? normalized : ACCESS_LEVELS.OWNER;
};

export const getProjectAccessLevel = (project = {}) => {
  if (!project) return ACCESS_LEVELS.OWNER;
  return normalizeAccessLevel(project.access_level ?? (project?.is_shared ? ACCESS_LEVELS.EDITOR : ACCESS_LEVELS.OWNER));
};

export const getProjectPermissions = (project) => {
  const level = getProjectAccessLevel(project);
  return DEFAULT_PERMISSIONS[level] || DEFAULT_PERMISSIONS[ACCESS_LEVELS.OWNER];
};

export const canRenameProject = (project) => getProjectPermissions(project).canRenameProject;
export const canDeleteProject = (project) => getProjectPermissions(project).canDeleteProject;
export const canEditProjectContent = (project) => getProjectPermissions(project).canEditProjectContent;

export const PROJECT_ACCESS_LEVELS = ACCESS_LEVELS;

/**
 * Derive a viewMode string from a project object (authenticated context).
 * Maps directly to the values consumed by ViewModeContext:
 *   'editor'  – owner or editor member (can write)
 *   'viewer'  – viewer member (read-only)
 *
 * Public / unauthenticated modes ('public-project', 'public-doc') are set
 * directly by the share-link layout roots and do not go through this helper.
 */
export const getViewMode = (project) => {
  const level = getProjectAccessLevel(project);
  if (level === ACCESS_LEVELS.VIEWER) return 'viewer';
  return 'editor';
};

